import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import HideIcon from "../../assets/images/icons/eye-icon-hide.svg";
import ShowIcon from "../../assets/images/icons/eye-icon-show.svg";
import "./inputComponent.css";

const InputComponent = ({
  type,
  placeholder,
  inputMode,
  maxLength,
  onPaste,
  onChange,
  message,
  customClass,
  value,
  onKeyDown,
  disabled,
}) => {
  const [showEyeIcon, setShowEyeIcon] = useState(false);
  const [checkType, setCheckType] = useState(false);

  useEffect(() => {
    if (type === "password") {
      setShowEyeIcon(true);
    } else {
      setShowEyeIcon(false);
    }
  }, []);

  const onHandleChangeType = () => {
    setCheckType(!checkType);
  };
  return (
    <>
      <div className={`input-container ${customClass}`}>
        <Form.Control
          className="input-box"
          type={checkType ? "text" : type}
          placeholder={placeholder}
          inputMode={inputMode}
          maxLength={maxLength}
          onPaste={onPaste}
          onChange={onChange}
          value={value}
          onKeyDown={onKeyDown}
          disabled={disabled}
        />
        {showEyeIcon ? (
          <div className="eye-icon" onClick={onHandleChangeType}>
            <img src={checkType ? ShowIcon : HideIcon} alt="eye-icon-hide" />
          </div>
        ) : (
          ""
        )}
      </div>
      <Form.Text id="emailText">{message}</Form.Text>
    </>
  );
};

export default InputComponent;
